import type { LotteryStatus } from 'api/lotteries';
import { lottery as fetchLottery, lotteryStatus } from 'api/lotteries';

// the channel docs show `tickets` both flat and nested in one more array
export const normalizeStatus = (status: LotteryStatus): LotteryStatus => ({
  ...status,
  tickets: (status.tickets ?? []).flat(),
  prizes: status.prizes ?? {},
});

/** a drawn lottery is reachable by id only, it leaves the enabled list */
export const fetchWonLottery = (id: number) =>
  Promise.all([fetchLottery(id), lotteryStatus(id)])
    .then(([{ data: lottery }, { data: status }]) =>
      // a 404 resolves, with no data
      lottery?.id && status
        ? { lottery, status: normalizeStatus(status) }
        : null
    )
    .catch(() => null);
